import { ReactNode, useEffect, useMemo } from 'react'
import { initialQueryState, useDebounce } from '../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import {
  ActiveFilter,
  ActiveFiltersBar,
  Input,
  TableFilter,
  TableFilters,
} from '../../../../../../components'

type Props = {
  /** Conteúdo à direita da linha dos campos (ex.: "Adicionar" ou barra de seleção em lote). */
  actions?: ReactNode
}

export const CargoClienteListSearchComponent = ({ actions }: Props) => {
  const { updateState } = useQueryRequest()
  const { response, isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const total = response?.totalElements ?? 0

  const debouncedFilters = useDebounce(filters, 500)

  const search = useMemo(() => {
    const nome = debouncedFilters.nome.trim()
    return nome ? `nome~*${nome}*` : ''
  }, [debouncedFilters])

  useEffect(() => {
    updateState({ ...initialQueryState, search })
  }, [search, updateState])

  // Chip da faixa "Filtros ativos": o × limpa o campo.
  const activeFilters: ActiveFilter[] = filters.nome.trim()
    ? [
        {
          key: 'nome',
          label: 'Cargo',
          value: `“${filters.nome.trim()}”`,
          onRemove: () => setFilter('nome', ''),
        },
      ]
    : []

  const resultado = isLoading
    ? 'Buscando…'
    : `${total} ${total === 1 ? 'cargo encontrado' : 'cargos encontrados'}`

  return (
    <TableFilters
      actions={actions}
      footer={
        <ActiveFiltersBar filters={activeFilters} onClearAll={clearFilters} summary={resultado} />
      }
    >
      <TableFilter label='Cargo' wide>
        <Input
          placeholder='Digite o cargo'
          value={filters.nome}
          onChange={(e) => setFilter('nome', e.target.value)}
        />
      </TableFilter>
    </TableFilters>
  )
}
